import { EsecuzioneConversazione, EsecuzioneDecisione } from './Executions'
import { descriviQuota, scenarioChiuso } from './Functions'
import { t } from './testi'

/** Il badge di esito di uno scenario: PASS, FAIL, grigio se saltato, in corso se mancano prove. */
export const Esito = ({ risultato }) => {
  if (risultato.saltato) return <span className="nbadge">{t.aeSaltato}</span>
  if (!scenarioChiuso(risultato)) return <span className="nbadge nbadge--info">{t.aeInCorso}</span>
  return (
    <span className={`nbadge ${risultato.passato ? 'nbadge--ok' : 'nbadge--err'}`}>
      {risultato.passato ? 'PASS' : 'FAIL'}
    </span>
  )
}

const ICONE_CONFRONTO = {
  migliorata: 'pi-arrow-up-right',
  peggiorata: 'pi-arrow-down-right',
  indistinguibile: 'pi-minus'
}
const TESTI_CONFRONTO = {
  migliorata: () => t.aeMigliorata,
  peggiorata: () => t.aePeggiorata,
  indistinguibile: () => t.aeIndistinguibile
}

/** Il confronto con la run precedente: freccia, parola e quota di prima. */
const Confronto = ({ confronto }) => (
  <span
    className={`ae-confronto is-${confronto.esito}`}
    title={`${t.aeRispettoAPrima}: ${t.aePrima} ${descriviQuota(confronto.successi, confronto.prove)}`}
  >
    <i className={`pi ${ICONE_CONFRONTO[confronto.esito] ?? 'pi-minus'}`} aria-hidden="true" />{' '}
    {TESTI_CONFRONTO[confronto.esito]?.() ?? confronto.esito}
    <span className="ae-muto">
      {' '}
      ({t.aePrima} {descriviQuota(confronto.successi, confronto.prove)})
    </span>
  </span>
)

/**
 * Uno scenario della run: riga con esito e quota; aperto solo se è chiuso e sotto soglia.
 * `aperto` è il valore iniziale: l'utente poi apre e chiude da sé.
 * @param {Object} props - Proprietà
 * @param {Object} props.r - Il risultato dello scenario
 * @param {boolean} [props.aperto] - Apertura iniziale (default: solo se sotto soglia)
 */
export const RisultatoScenario = ({ r, aperto }) => {
  const chiuso = scenarioChiuso(r)
  return (
    <details className="ae-scenario" open={aperto ?? (chiuso && !r.passato)}>
      <summary>
        <Esito risultato={r} />
        <strong className="ae-scenario__id">{r.id}</strong>
        {r.saltato ? (
          <span className="ae-muto">{r.saltato}</span>
        ) : (
          <span className="ae-scenario__dati">
            <span>
              {chiuso
                ? descriviQuota(r.successi, r.prove, r.intervallo)
                : `${r.prove}/${r.proveAttese ?? r.prove}`}
            </span>
            <span className="ae-muto">
              {t.aeSoglia} {Math.round(r.soglia * 100)}%
            </span>
            {r.confronto ? <Confronto confronto={r.confronto} /> : null}
          </span>
        )}
      </summary>
      <div className="ae-scenario__corpo">
        <p className="ae-muto">
          {r.descrizione} — {r.origine}
        </p>
        {r.situazione ? <p className="ae-situazione">{r.situazione}</p> : null}
        {r.distribuzione ? (
          <ul className="ae-distribuzione">
            {Object.entries(r.distribuzione)
              .sort((a, b) => b[1] - a[1])
              .map(([mossa, volte]) => (
                <li key={mossa}>
                  {mossa}: {descriviQuota(volte, r.prove)}
                </li>
              ))}
          </ul>
        ) : null}
        {chiuso && r.controlliCaduti?.length ? (
          <ul className="ae-caduti">
            {r.controlliCaduti.map((c) => (
              <li key={c.nome}>
                <strong>
                  {c.volte}× {c.nome}
                </strong>
                {(c.detail ?? c.dettaglio) ? <span> — {c.detail ?? c.dettaglio}</span> : null}
              </li>
            ))}
          </ul>
        ) : null}
        {r.esecuzioni?.map((e, i) =>
          r.tipo === 'decisione' ? (
            <EsecuzioneDecisione key={i} esecuzione={e} indice={i} />
          ) : (
            <EsecuzioneConversazione key={i} esecuzione={e} indice={i} />
          )
        )}
      </div>
    </details>
  )
}
